import { formatter } from "../..";
export function dumpGtx(gtxTx) {
    var _a;
    return `blockchainRid:\n${formatter.toString(gtxTx.blockchainRid)}\n
operations:
${gtxTx.operations.map(op => ` - ${op.opName}(${op.args.map(dumpGtv).join(", ")})\n`).join("")}
signers:
${gtxTx.signers.map(s => ` - ${formatter.toString(s)}\n`).join("")}
signatures:
${(_a = gtxTx.signatures) === null || _a === void 0 ? void 0 : _a.map(s => ` - ${formatter.toString(s)}\n`).join("")}`;
}
export function dumpGtv(rawGtv) {
    return JSON.stringify(rawGtv, (_key, value) => {
        if (typeof value === "bigint") {
            return `${value.toString()}L`;
        }
        if (Buffer.isBuffer(value)) {
            return formatter.toString(value);
        }
        if (typeof value === "object" &&
            value !== null &&
            value.type === "Buffer" &&
            Array.isArray(value.data)) {
            return `0x${value.data}`;
        }
        return value;
    });
}
//# sourceMappingURL=dump.js.map